import { MaskLines, Reveal } from "./motion";
import { Cta } from "./Cta";
import { SITE, ADDRESS_LINE } from "../content/site";

export function VisitBand({ testId = "visit-band" }) {
  return (
    <section className="relative overflow-hidden bg-[#781C31]" data-testid={testId}>
      <div className="mx-auto grid max-w-[1440px] gap-10 px-5 py-20 sm:px-8 lg:grid-cols-12 lg:px-12 lg:py-28">
        <div className="lg:col-span-8">
          <p className="eyebrow !text-[#F6F2F0]/80">This Sunday</p>
          <MaskLines
            lines={["Come as you are.", "Leave equipped."]}
            className="mt-6 font-display text-5xl font-bold uppercase leading-[0.9] tracking-tight text-[#F6F2F0] sm:text-7xl lg:text-8xl"
          />
        </div>
        <Reveal className="flex flex-col justify-end gap-6 lg:col-span-4">
          <p className="text-base leading-relaxed text-[#F6F2F0]/90">
            {SITE.sunday.day}s at {SITE.sunday.time}
            <br />
            {ADDRESS_LINE}
          </p>
          <div className="flex flex-col gap-3 sm:flex-row lg:flex-col">
            <Cta to="/visit" variant="light" testId={`${testId}-plan-visit`}>Plan Your Visit</Cta>
            <Cta href={SITE.youtube} variant="ghost" testId={`${testId}-youtube`}>Watch on YouTube</Cta>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
